import axios from 'axios';
import { BASE_URL } from '../ApiService/ApiConfig';

const URL_BASE = BASE_URL;

const obtenerConfig = () => {
    // Manejo seguro del token (elimina comillas si existen)
    const token = localStorage.getItem('jwt')?.replaceAll('"', '') || '';

    return {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        }
    };
};

export const obtenerMapaConfiguraciones = async (codigoTipoModulo) => {
    try {
        const response = await axios.get(
            `${URL_BASE}/simpleConfiguracionCab/mapa/${codigoTipoModulo}`,
            obtenerConfig()
        );
        return response.data;
    } catch (error) {
        console.error('Error obteniendo mapa de configuraciones:', error.message);
        // Es buena práctica lanzar el error para que el componente (Hook) sepa que falló
        throw error;
    }
};

export const obtenerConfByTipo = async (codigoTipo) => {
    try {
        const response = await axios.get(
            `${URL_BASE}/simpleConfiguracionCab/tipo/${codigoTipo}`,
            obtenerConfig()
        );
        return response.data;
    } catch (error) {
        console.error('Error obteniendo configuraciones por Tipo', error.message);
        throw error;
    }
};
